export default function GridPreview({ result }) {
  if (!result) return null;
  const g = result.geometry;
  const [prim, sec] = result.members;
  const W = g.width_m, H = g.height_m;
  const pad = Math.max(W, H) * 0.08;
  const vw = W + pad * 2, vh = H + pad * 2;
  const s = Math.max(W, H) / 400;
  const pw = Math.max(prim.width_mm / 1000, s * 1.5), sw = Math.max(sec.width_mm / 1000, s);
  const xs = g.v_lines, ys = [...new Set(g.h_lines)].sort((a, b) => a - b);
  const showLabels = (xs.length - 1) * (ys.length - 1) <= 80;
  const fs = Math.max(W, H) / 45;
  const flipY = (y) => pad + H - y;

  return (
    <div className="rounded-lg border border-zinc-800 bg-[#0c0c0f] p-3" data-testid="grid-preview">
      <div className="mb-2 flex items-center justify-between font-mono text-[11px] uppercase tracking-wider text-zinc-500">
        <span>{g.view} preview</span>
        <span><span className="text-sky-400">■</span> {g.primary} <span className="ml-2 text-emerald-400">■</span> {g.secondary}</span>
      </div>
      <svg viewBox={`0 0 ${vw} ${vh}`} className="h-auto max-h-[460px] w-full">
        <defs>
          <linearGradient id="glass" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#0e7490" stopOpacity="0.35" />
            <stop offset="0.5" stopColor="#67e8f9" stopOpacity="0.18" />
            <stop offset="1" stopColor="#0e7490" stopOpacity="0.35" />
          </linearGradient>
        </defs>
        <rect x={pad} y={pad} width={W} height={H} fill="url(#glass)" stroke="#a1a1aa" strokeWidth={s} />
        {showLabels && xs.slice(0, -1).map((x, i) => ys.slice(0, -1).map((y, j) => (
          <text key={`g-${x}-${y}`} x={pad + (x + xs[i + 1]) / 2} y={flipY((y + ys[j + 1]) / 2)} fontSize={fs * 0.6} fill="#71717a" textAnchor="middle" dominantBaseline="middle" fontFamily="JetBrains Mono">
            G{i * (ys.length - 1) + j + 1}
          </text>
        )))}
        {ys.map((y) => <rect key={`h${y}`} x={pad} y={flipY(y) - sw / 2} width={W} height={sw} fill="#10b981" />)}
        {xs.map((x) => <rect key={`v${x}`} x={pad + x - pw / 2} y={pad} width={pw} height={H} fill="#0ea5e9" />)}
        {g.floor_lines.map((y) => <line key={`f${y}`} x1={pad * 0.4} x2={pad + W + pad * 0.6} y1={flipY(y)} y2={flipY(y)} stroke="#ef4444" strokeWidth={s} strokeDasharray={`${s * 6} ${s * 4}`} />)}
        <line x1={pad} x2={pad + W} y1={pad + H + pad * 0.5} y2={pad + H + pad * 0.5} stroke="#f59e0b" strokeWidth={s} />
        <text x={pad + W / 2} y={pad + H + pad * 0.85} fontSize={fs} fill="#f59e0b" textAnchor="middle" fontFamily="JetBrains Mono">{Math.round(W * 1000)} mm</text>
        <line x1={pad * 0.5} x2={pad * 0.5} y1={pad} y2={pad + H} stroke="#f59e0b" strokeWidth={s} />
        <text x={pad * 0.35} y={pad + H / 2} fontSize={fs} fill="#f59e0b" textAnchor="middle" fontFamily="JetBrains Mono" transform={`rotate(-90 ${pad * 0.35} ${pad + H / 2})`}>{Math.round(H * 1000)} mm</text>
      </svg>
    </div>
  );
}
